import React, { useContext } from 'react';
import axios from 'axios';
import { ShieldAlert } from 'lucide-react';
import { AuthContext } from '../App';
import { getSite } from '../lib/site';

// Shown when a signed-in company user (or an impersonation session) opens /superadmin: explains why and offers the right exit.
export const SuperAdminGate = () => {
  const { user, logout } = useContext(AuthContext);
  const companyName = user?.company?.name || user?.company_name || 'your company';
  const impersonating = Boolean(user?.impersonating);

  const endImpersonation = async () => {
    try { await axios.post('/superadmin/impersonation/end'); } catch (e) { /* session may already be closed */ }
    const saToken = localStorage.getItem('superadmin_token');
    if (saToken) localStorage.setItem('token', saToken); else localStorage.removeItem('token');
    localStorage.removeItem('superadmin_token');
    window.location.href = '/superadmin';
  };

  const switchAccount = () => {
    logout();
    if (getSite().platform?.preview) sessionStorage.setItem('site_preview', 'admin');
    window.location.href = '/login';
  };

  return (
    <div data-testid="superadmin-gate" style={{ minHeight: '100vh', background: '#0A0A0A', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ maxWidth: 520, background: '#141414', border: '1px solid #27272A', padding: 32 }}>
        <ShieldAlert size={28} color="#ef4444" />
        <h1 style={{ fontSize: 22, fontWeight: 800, margin: '14px 0 8px' }}>Super Admin needs its own session</h1>
        <p data-testid="superadmin-gate-text" style={{ color: '#A1A1AA', fontSize: 14, lineHeight: 1.6 }}>
          {impersonating
            ? <>You are currently <b style={{ color: '#fff' }}>impersonating {companyName}</b>. End the impersonation session to get back to the Super Admin console.</>
            : <>You are signed in as <b style={{ color: '#fff' }}>{user?.email}</b> ({companyName}). Company staff accounts cannot open the Super Admin console — sign out and log in with the Super Admin account.</>}
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
          {impersonating
            ? <button type="button" data-testid="superadmin-gate-exit-impersonation" onClick={endImpersonation} style={btn}>End impersonation → Super Admin</button>
            : <button type="button" data-testid="superadmin-gate-switch" onClick={switchAccount} style={btn}>Sign out & open Super Admin login</button>}
          <a href="/" data-testid="superadmin-gate-back" style={{ ...btn, background: 'transparent', border: '1px solid #3F3F46', color: '#fff', textDecoration: 'none' }}>Back to {companyName}</a>
        </div>
      </div>
    </div>
  );
};

const btn = { background: '#dc2626', color: '#fff', border: 'none', padding: '10px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer', letterSpacing: '0.04em', textTransform: 'uppercase' };
